import { ContentCardEffects } from './content-card.effect';

export const effects = [ContentCardEffects];
export * from './content-card.effect';
